import AccountOrdersPage from '@fhs-legacy/frontend/src/pages/account/account-orders';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default AccountOrdersPage;
